
export const montoNull = {
    inserted(el, binding) {
        if (binding.value && binding.value !== 0) {
            el.innerHTML = binding.value;
        } else{
            el.innerHTML = "-"
        }

    },
    update(el, binding) {
        if (binding.value && binding.value !== 0) {
            el.innerHTML = binding.value;
        } else{
            el.innerHTML = "-"
        }
    }
};




// WEBPACK FOOTER //
// ./src/directives/montoNull.js